var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEditController } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { getLanguages } from "@sequentech/ui-core";
var SettingsLanguagesStyles = {
    Wrapper: styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Content: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "], ["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "]))),
    Text: styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        text-transform: capitalize;\n    "], ["\n        text-transform: capitalize;\n    "]))),
};
export var SettingsLanguages = function () {
    var _a, _b;
    var tenantId = useTenantStore()[0];
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var listLangs = getLanguages(i18n);
    var _d = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _d.record, save = _d.save, isLoading = _d.isLoading;
    var defaultLanguageConf = {
        enabled_language_codes: ["en"],
        default_language_code: "en",
    };
    var _e = useState((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf), languageConf = _e[0], setLanguageConf = _e[1];
    var checkIncludesLang = function (lang) { var _a, _b; return (_b = (_a = languageConf.enabled_language_codes) === null || _a === void 0 ? void 0 : _a.includes(lang)) !== null && _b !== void 0 ? _b : false; };
    var handleToggle = function (lang) {
        var _a, _b;
        var includesLang = checkIncludesLang(lang);
        var currentLangs = (_a = languageConf.enabled_language_codes) !== null && _a !== void 0 ? _a : [];
        var enabledLangs = includesLang
            ? currentLangs.filter(function (code) { return code !== lang; })
            : __spreadArray(__spreadArray([], currentLangs, true), [lang], false);
        var updatedLanguageConf = __assign(__assign({}, languageConf), { enabled_language_codes: enabledLangs });
        setLanguageConf(updatedLanguageConf);
        if (save) {
            save({
                settings: __assign(__assign({}, ((_b = record === null || record === void 0 ? void 0 : record.settings) !== null && _b !== void 0 ? _b : {})), { language_conf: updatedLanguageConf }),
            });
        }
    };
    useEffect(function () {
        var _a, _b;
        if (record.settings) {
            setLanguageConf((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf);
        }
    }, [record]);
    if (isLoading)
        return null;
    return (_jsxs(SettingsLanguagesStyles.Wrapper, { children: [_jsx(Typography, __assign({ variant: "body2", paragraph: true }, { children: t("generalSettingsScreen.body") })), listLangs.map(function (lang) { return (_jsxs(SettingsLanguagesStyles.Content, { children: [_jsx(SettingsLanguagesStyles.Text, { children: t("language", { lng: lang }) }), _jsx(Switch, { checked: checkIncludesLang(lang), onChange: function () { return handleToggle(lang); } })] }, lang)); })] }));
};
var templateObject_1, templateObject_2, templateObject_3;
